import { render, staticRenderFns } from "./InlineAccountModal.vue?vue&type=template&id=ac478416&lang=pug"
import script from "./InlineAccountModal.vue?vue&type=script&lang=js"
export * from "./InlineAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InlineAccountTabs: require('/home/docker/code/frontend/components/InlineAccountTabs.vue').default})
